import { render, staticRenderFns } from "./PxCamposCompraItemTableTotvs.vue?vue&type=template&id=7e5e6bfe&"
import script from "./PxCamposCompraItemTableTotvs.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemTableTotvs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports